<header class="header">
  <div class="forefront" [ngClass]="{'transparent': isTransparent}">
    <div class="layout">



      <button class="open-menu-mobile button-mobile" aria-label="Abrir Menu" (click)="toggleSideMenu()">
        <i class="fas fa-bars"></i>
      </button>

      <nav *ngIf="isSideMenuActive" aria-label="Menu Lateral" class="side-menu active">
        <div class="side-menu-content">
          <button class="close-menu-mobile button-mobile" aria-label="Fechar Menu" (click)="toggleSideMenu()">
            <i class="mdi mdi-close"></i>
          </button>
          <br>
          <ul id="side-menu-header-menu" class="menu">
            <li class="menu-item"><a href="/institucional/">Institucional</a></li>
            <li class="menu-item"><a href="/areas-de-atuacao/">Áreas de Atuação</a></li>
            <li class="menu-item"><a href="/solucoes/">Soluções</a></li>
            <li class="menu-item"><a href="/unidades/">Nossa Rede</a></li>
            <li class="menu-item"><a href="/blog/">Blog</a></li>
            <li class="menu-item"><a href="/contato/">Contato</a></li>
          </ul>
          <br>
          <hr>
          <a class="btn transparent trigger-menu-system" href="/login">Acessar Sistema</a>
          <br>
          <ul id="side-menu-sistema-menu" class="menu">
            <li class="menu-item"><a href="/login">Consultas Veiculares</a></li>
            <li class="menu-item"><a href="https://plataforma.distribuidor.digital/autenticacao">Consultas de
                Crédito</a></li>
          </ul>
        </div>
      </nav>


      <figure class="logo">
        <a href="/">
          <img class="img-logo"
            src="https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/Logo_Union_Branco.svg"
            alt="Union Solutions" style="width: 120px;" loading="lazy">
        </a>
      </figure>


      <nav aria-label="Navegação Principal" class="menu-nav">
        <ul id="menu-header-menu" class="menu d-flex">
          <li class="menu-item"><a href="/institucional/">Institucional</a></li>
          <li class="menu-item"><a href="/areas-de-atuacao/">Áreas de Atuação</a></li>
          <li class="menu-item"><a href="/solucoes/">Soluções</a></li>
          <li class="menu-item"><a href="/unidades/">Nossa Rede</a></li>
          <li class="menu-item"><a href="/blog/">Blog</a></li>
          <li class="menu-item"><a href="/contato/">Contato</a></li>
        </ul>
      </nav>


      <nav aria-label="Navegação Sistema" class="button-system">
        <a class="btn transparent trigger-menu-system" href="/login">Acessar Sistema</a>
        <div class="system-menu-navigation" [ngClass]="{'active': isMenuActive}">
          <ul id="menu-sistema-menu" class="menu">
            <li class="menu-item"><a href="/login">Consultas Veiculares</a></li>
            <li class="menu-item"><a href="https://plataforma.distribuidor.digital/autenticacao">Consultas de
                Crédito</a></li>
          </ul>
        </div>
      </nav>



    </div>
  </div>
</header>

<div class="overlay" [ngClass]="{'active': isSideMenuActive}" (click)="toggleSideMenu()"></div>
